import React, { useState, useEffect } from "react";
import { object } from "prop-types";
import get from "lodash/get";
import Separator from "../../atoms/separator";
import ElectionConstituencySearchBar from "../../atoms/election-constituency-search-bar";

import { assemblyElection2024Records } from "../../molecules/election-brick-wall-with-search/election-data-2024";

const Records = [...assemblyElection2024Records];

import "./election-widget-with-search.m.css";

const ElectionWidgetWithSearch = ({ collection, collectionSlug }) => {
  const [pathname, setPathname] = useState("");
  useEffect(() => {
    if (typeof window !== "undefined") {
      const pathname = window.location.pathname.slice(1);
      setPathname(pathname);
    }
  }, []);

  const content = get(collection, ["associated-metadata", "content"], "");

  const updatedRecords =
    collectionSlug === "delhi-assembly-elections-2025" ? Records.slice(0, 70) :
      Records.slice(0, 369)

  return (
    <div styleName="border-wrapper">
      <div styleName="wrapper" dangerouslySetInnerHTML={{ __html: content }}></div>
      {/* {stateElections2024SlugData.map((statedata) => {
        return statedata?.slug === pathname && <ElectionConstituencySearchBar Records={Records} />;
      })} */}
      <ElectionConstituencySearchBar Records={updatedRecords} />
      {collectionSlug === "assembly-elections-2024" && <Separator />}
    </div>
  );
};

ElectionWidgetWithSearch.propTypes = {
  collection: object
};

export default ElectionWidgetWithSearch;
